import { useRef, useState } from "react";
import { Whisper, Popover, Tooltip } from "rsuite";

import WorkspaceSwitcherOptions from "./WorkspaceSwitcherOptions";
import useWorkspaces from "../../../api/api-hooks/workspaces/useWorkspaces";
import useWorkspace from "../../../api/api-hooks/workspaces/useWorkspace";
import useToggle from "../../../hooks/useToggle";
import EditWorkspaceDrawer from "../../Drawers/EditWorkspaceDrawer/EditWorkspaceDrawer";
import Divider from "../../../elements/Divider";

const WorkspaceSwitcher = ({ sidebarOpen }: { sidebarOpen: boolean }) => {
  const { workspacesLoading } = useWorkspaces();
  const { workspace, workspaceLoading } = useWorkspace();
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen((prev) => !prev);
  const [modalOpen, toggleModal] = useToggle();
  const wsRef = useRef<any>();

  const closePopover = () => wsRef.current.close();

  const openModal = () => {
    closePopover();
    toggleModal();
  };

  const closeModal = () => {
    toggleModal();
  };

  return (
    <div className="d-xs-block d-md-none">
      <Divider />
      <Whisper
        placement={sidebarOpen ? "autoVerticalStart" : "autoHorizontalStart"}
        controlId="workspace-switcher"
        trigger="click"
        onClose={() => setOpen(false)}
        ref={wsRef}
        speaker={
          <Popover
            className="sidebar-popover"
            full
            onClick={(e: any) => e.stopPropagation()}
          >
            <WorkspaceSwitcherOptions
              toggleModal={openModal}
              closePopover={closePopover}
            />
          </Popover>
        }
      >
        {sidebarOpen ? (
          <div
            className={`workspace-switcher ${open ? "ws-open" : ""}`}
            onClick={toggleOpen}
          >
            <div className="ws-left">
              <i className="mdi mdi-view-dashboard-outline ws-icon" />
              <div className="text-truncate ws-name" style={{ width: 160 }}>
                {workspaceLoading || workspacesLoading ? (
                  <div
                    style={{ width: "100%", height: 20 }}
                    className="skeleton"
                  ></div>
                ) : (
                  workspace?.Name ?? "Choose A Workspace"
                )}
              </div>
            </div>
            <i
              className={`mdi mdi-chevron-${
                open ? "down" : "right"
              } ws-chevron`}
            />
          </div>
        ) : (
          <div>
            <Whisper
              placement="right"
              controlId={`tooltipHoverWorkspace`}
              trigger="hover"
              speaker={
                <Tooltip>
                  {workspaceLoading || workspacesLoading
                    ? ""
                    : workspace?.Name ?? "Choose A Workspace"}
                </Tooltip>
              }
            >
              <div className="text-center sidebar-link  px-2 py-1 mx-2 link-hovered">
                <i
                  className="mdi mdi-view-dashboard-outline"
                  style={{ fontSize: 18 }}
                />
              </div>
            </Whisper>
          </div>
        )}
      </Whisper>
      <EditWorkspaceDrawer open={modalOpen} handleClose={closeModal} />
    </div>
  );
};

export default WorkspaceSwitcher;
